export const BuildInfo = {timestamp:1778874348000}
